<script lang="ts" setup>
const emit = defineEmits(['selectCategory'])

const { getGenres } = useGenres()

const { data } = useAsyncData('genres', () => getGenres(), {
  getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key] || nuxtApp.static.data[key],
  transform: data => data?.results
})

const selectedCategory = ref<number | null>(null)

watch(selectedCategory, () => {
  emit('selectCategory', selectedCategory.value)
})
</script>

<template>
  <DragToScroll>
    <div class="py-5 flex gap-4 flex-nowrap justify-start items-center min-w-max">
      <span class="text-xl sm:text-2xl font-bold text-slate-100">Categorias</span>

      <UButton
        color="primary"
        variant="outline"
        icon="i-heroicons-view-columns"
        :ui="{
          base: 'rounded-full flex items-center justify-center text-nowrap text-xs sm:text-sm'
        }"
        @click="selectedCategory = null"
      >
        Ver todos
      </UButton>

      <UButton
        v-for="category in data"
        :key="category.id"
        color="secondary"
        variant="solid"
        :icon="selectedCategory === category.id ? 'i-heroicons-check' : null"
        :ui="{
          base: 'text-slate-200 rounded-full flex items-center justify-center text-nowrap text-xs sm:text-sm',
          leadingIcon: 'size-4 sm:size-5'
        }"
        @click="selectedCategory = category.id"
      >
        {{ translateCategory(category.name) }}
      </UButton>
    </div>
  </DragToScroll>
</template>
